import React, { createContext, useContext } from 'react';

const EMPTY_HOST_SEEDED_FORM_KEYS: ReadonlySet<string> = new Set();

const HostSeededFormKeysContext = createContext<ReadonlySet<string>>(
  EMPTY_HOST_SEEDED_FORM_KEYS,
);

/**
 * Keys whose values were applied from the host seed on this landing step.
 * Bound controls use this to drop a seeded value that matches no option,
 * and only on the first options load. Absent outside a Dynamic Experience.
 */
export const HostSeededFormKeysProvider: React.FC<{
  readonly keys: ReadonlySet<string>;
  readonly children: React.ReactNode;
}> = ({ keys, children }) => (
  <HostSeededFormKeysContext.Provider value={keys}>
    {children}
  </HostSeededFormKeysContext.Provider>
);

export function useHostSeededFormKeys(): ReadonlySet<string> {
  return useContext(HostSeededFormKeysContext);
}
